export function normalizeAuthEmail(email: string): string {
  return email.trim().toLowerCase();
}

/** Generic login failure — avoids email / provider enumeration. */
export const GENERIC_LOGIN_FAILURE_MESSAGE =
  'Email or password is incorrect. Use the same credentials as the JK Loom mobile app, ' +
  'or use Forgot Password if you have an existing account.';

/** Shown after a reset request regardless of whether the email exists. */
export const PASSWORD_RESET_SENT_MESSAGE =
  'If an account exists for that email, you will receive password reset instructions shortly. ' +
  'The new password works for both web and mobile.';
